export default __webpack_public_path__ + "static/image-ping-coming-soon-2baee5c6efaa56e2dd0e7b6deb854538.png";